import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=66e9e615&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e9e615"]])

export default __exports__